import { Colors } from '@/common/colors/colors';
import styled from 'styled-components';

export const Icon = styled.i`
	cursor: pointer;
	color: ${Colors.darkBlue};
`;
